import SmoothScroll from 'smooth-scroll';
import $ from 'jquery';
export default {
  // window
  $window: $(window),
  $body: $('body'),
  windowAttr: {
    width: window.innerWidth,
    height: window.innerHeight,
    top: window.pageYOffset
  },
  // breakpoint
  base_w: 768,
  // header
  $headNav: $('#siteHeader'),
  // gnav
  $gnav: $('#globalNav'),
  // gnav click area
  $clickArea: $('#navBtn, #globalNav a[href*="#"], #overlay'),
  // active fg
  _openFg: false,
  _padding: '0px',
  // gnav sp inner list
  $gnavSp: $('#spNav .list-parent'),
  // gnav sp inner list activeflg
  spNavFg: [],
  // scroll
  scrollpos: 0,
  //-----------------------------
  // 現在地取得（カレント表示）
  //-----------------------------
  navLink: $('#globalNav ul li a.is-anchor'),
  contentsArr: new Array(),
  init: function init() {
    // window size reget
    this.windowAttr = {
      width: window.innerWidth,
      height: window.innerHeight,
      top: window.pageYOffset
    };
    this.gmenu(); // gnav

    this.loading();
  },
  finalize: function finalize() {
    var self = this;
    var scroll = new SmoothScroll('a[href*="#"], [data-scroll]', {
      speed: 800,
      speedAsDuration: true,
      ignore: '.inline, .noScrl',
      // offset: offset,
      updateURL: false
    }); // top へ戻る追従

    var jQueryWindow = this.$window; // ウィンドウを指定

    var jQueryChange = $('#topBtn'); // #change 部分

    var topContent = $('#mainContents').offset().top; // #mainContents の位置を取得

    var sticky = false;
    jQueryWindow.on('scroll', function () {
      if (jQueryWindow.scrollTop() > topContent) {
        // scroll 位置が #mainContents の上にある場合
        if (sticky === false) {
          // #change 部分が降りてくる。
          jQueryChange.slideDown();
          sticky = true;
        }
      } else {
        // scroll 位置が下にある場合
        if (sticky === true) {
          // #change 部分が上がる。
          jQueryChange.slideUp();
          sticky = false;
        }
      }
    }).trigger('scroll');
    this.navLink.on('click', function () {
      var responsibleCheck = $('#responsibleCheck').width();
      var $animateDom = $($(this).attr('href')); // - 99 は高さ位置の調整

      if ($animateDom[0]) {
        $('html, body').animate({
          scrollTop: $animateDom.offset().top - 99
        }, 800);
      }

      if (responsibleCheck === 2) {
        // 内容非表示
        $('#siteHeader').removeClass('is-open');
        $('#navBtn').removeClass('active');
        $('#navBtn').find('span').removeClass('iconClose');
      }

      return false;
    });

    var link = function link(event) {
      if (window.innerWidth > 1023) {
        var _this = this;

        var _photo = $(_this).find('.c-blog-grid-list-photo');

        $(_this).off('mouseenter');
        $(_photo).animate2({
          transform: 'perspective(400px) rotateY(-5deg) rotateX(5deg)'
        }, 300);
        $(_photo).queue(function () {
          $(this).dequeue();
        });
        $(_this).on('mouseleave', function (event) {
          $(_this).off('mouseleave');
          $(_photo).animate2({
            transform: 'perspective(0px) rotateY(0deg) rotateX(0deg)'
          }, 300);
          $(_photo).queue(function () {
            $(_this).on('mouseenter', link);
            $(this).dequeue();
          });
        });
      }
    };

    $('.c-blog-grid-list-link').on('mouseenter', link);
    var urlHash = location.hash;
    var referrer = document.referrer; // 高さ位置の調整

    if (urlHash && referrer !== undefined) {
      $('html, body').scrollTop($('#siteHeader').offset().top - $('#siteHeader').height());
    }
  },
  // gnav
  gmenu: function gmenu() {
    var self = this;

    for (var i = 0, max = this.$gnavSp.length; i < max; i++) {
      this.spNavFg[i] = false;
    } // $('html').removeclass('scroll-prevent');


    self.$gnavSp.on('click', function () {
      var $this = $(this);

      var _idx = self.$gnavSp.index($this);

      if (self.spNavFg[_idx]) {
        $this.removeClass('is-open');
      } else {
        $this.addClass('is-open');
      }

      self.spNavFg[_idx] = self.spNavFg[_idx] ? false : true;
    });
    this.$clickArea.on('click', function () {
      var $this = $(this);

      if ($('.l-header.is-open')[0] || $('#navBtn').is(':visible')) {
        self._openFg = self._openFg ? false : true;
        self._padding = self._openFg ? '50px' : '0px';

        if (self.windowAttr.width <= self.base_w) {
          self.$gnav.css({
            'padding-bottom': self._padding
          });
        }

        if (self._openFg == false) {
          self.$headNav.removeClass('is-open');
          self.$body.removeClass('scroll-prevent').css({
            'top': 0
          });
          window.scrollTo(0, self.scrollpos);
        } else {
          self.$headNav.addClass('is-open');
          self.scrollpos = self.$window.scrollTop();
          self.$body.addClass('scroll-prevent').css({
            'top': -self.scrollpos
          });
        }
      } else {
        if ($this.hasClass('is-anchor')) {
          return false;
        }
      }
    });
  },
  loading: function loading() {
    $('#loader .loader').fadeOut(1000, function () {
      $('#loader').fadeOut(800);
    });
  }
};